import React, { lazy, Suspense, useEffect, useRef } from 'react';
import ErrorBoundary from 'src/error/components/ErrorBoundary';
import { useGetFlagSigmaOptionByName } from 'src/utils/featureToggleSigma/hooks/useGetFlagSigmaOptionByName';
import { useOpen } from './hooks/useOpen';
import { COUNT_OPEN_EXPENSIVE_HOTEL_PAGE } from './constants';

const ExpensiveHotelsPopup = lazy(
  () =>
    import(
      /* webpackChunkName: "ExpensiveHotelsPopup" */ './components/ExpensiveHotelsPopup'
    ),
);

interface Props {
  pricePerNightPerPerson: number;
}

export const LazyExpensiveHotelsPopup = ({ pricePerNightPerPerson }: Props) => {
  const { value } = useGetFlagSigmaOptionByName('tour_selection');
  const countRef = useRef<number>(
    Number(localStorage.getItem(COUNT_OPEN_EXPENSIVE_HOTEL_PAGE)),
  );

  const { isOpened, setIsOpened } = useOpen(
    countRef.current,
    value,
    pricePerNightPerPerson,
  );

  const onClose = () => {
    setIsOpened(false);
  };

  useEffect(() => {
    if (value && pricePerNightPerPerson >= Number(value)) {
      localStorage.setItem(
        COUNT_OPEN_EXPENSIVE_HOTEL_PAGE,
        (countRef.current + 1).toString(),
      );
    }
  }, [value, pricePerNightPerPerson]);

  return (
    <ErrorBoundary showDialog={false}>
      <Suspense fallback={null}>
        {isOpened && <ExpensiveHotelsPopup onClose={onClose} />}
      </Suspense>
    </ErrorBoundary>
  );
};
